import React from "react";

const EmptyAccountState = () => {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="max-w-2xl w-full p-12 text-center">
        <div className="text-7xl mb-6">📊</div>

        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
          Get Started with Your First Import
        </h2>

        <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
          Drag and drop your Fidelity Activity Report CSV anywhere on this page
        </p>

        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 text-left max-w-lg mx-auto">
          <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
            💡 How to get your CSV:
          </h3>
          <ol className="text-sm text-gray-600 dark:text-gray-400 space-y-2 list-decimal list-inside">
            <li>Log into Fidelity.com</li>
            <li>Go to Accounts → Activity & Orders</li>
            <li>Download "Activity Report" as CSV</li>
            <li>Drag the file anywhere on this page</li>
          </ol>
        </div>

        <div className="mt-6 text-sm text-gray-500 dark:text-gray-500">
          Your holdings and performance will be calculated automatically
        </div>
      </div>
    </div>
  );
};

export default EmptyAccountState;
